import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Dropdown,
  Button,
  OverlayTrigger,
  Tooltip,
  Modal,
  Form,
} from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import ProfileHeader from "../../../components/profile-header";
import CustomToggle from "../../../components/dropdowns";
import CreatePost from "../../../components/create-post";
import ShareOffcanvas from "../../../components/share-offcanvas";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { formatDistanceToNow } from "date-fns";
import { AiOutlineLike } from "react-icons/ai";
import { BiSolidLike } from "react-icons/bi";
import { IoSendSharp } from "react-icons/io5";

//image
import header from "../../../assets/images/page-img/profile-bg7.jpg";
import axios from "axios";
import { webServiceUrl } from "../../../components/apiCall/webserviceurl";
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Oval } from "react-loader-spinner";
import Loading from "../../../components/common/Loading";
import Skeleton from "react-loading-skeleton";
import { MdComment } from "react-icons/md";


const GroupDetail = () => {
  const location = useLocation();
  // console.log(location);
  const course = location?.state?.item ?? {};
  const courseData = course?.student ?? localStorage.getItem("userId");
  // console.log(course, "course details at groupdetails ...........");
  // console.log(course?.student, "course details at groupdetails ...........");
  const handleShow = () => setShow(true);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const [show2, setShow2] = useState(false);
  const handleClose2 = () => setShow2(false);
  const handleShow2 = () => setShow2(true);
  const options = [
    'Delete',
  ];
  const ITEM_HEIGHT = 48;

  const [anchorEl, setAnchorEl] = useState(null);
  const [activePostId, setActivePostId] = useState(null); // Track which post opened the menu

  const [postLoading, setPostLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);
  const [imageLoading, setImageLoading] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setPageLoading(false), 1000);
    return () => clearTimeout(timer); // cleanup
  }, []);


  const handleClick = (event, postId) => {
    setAnchorEl(event.currentTarget);
    setActivePostId(postId); // Save the post_id of the clicked item
  };
  const handleClose3 = () => {
    setAnchorEl(null);
  };

  const handleDelete = async (option, id) => {
    try {
      console.log(option, "option value");
      console.log(id, "post id");

      const resp = await axios.post(webServiceUrl.delete_post, {
        post_id: id,
        school_code: course?.school_code,
      });

      console.log(resp);

      if (resp?.data?.success) {
        toast.success("Post deleted successfully!");
        // Optional: refresh list or update UI here
        getGroupPost()
      } else {
        toast.error(resp?.data?.message || "Failed to delete post.");
      }
    } catch (error) {
      console.error("Delete error:", error);
      toast.error("Something went wrong while deleting the post.");
    }
  };


  const [data, setData] = useState({});
  const [groupposts, setGroupPosts] = useState([]);

  const [appreciateUsers, setAppreciateUsers] = useState({
    message: "",
    sender_id: 12345,
    receiver_id: 67890,
  });

  const [nominateUsers, setNominateUsers] = useState({
    nomination: "",
    message: "",
    receiver_id: 12345,
    sender_id: 67890,
  });
  const [postData, setPostData] = useState({
    school_code: course?.school_code,
    post_description: "",
    created_by_id: courseData?.student_id,
    created_sender_name: courseData?.student_name,
    post_img: "",
  });
  const [commentData, setCommentData] = useState({
    school_code: course?.school_code,
    post_id: "",
    comment: "",
    commented_by_id: courseData?.student_id,
    commented_sender_name: courseData?.student_name,
  });
  console.log(commentData, "commentData.........................");

  /****************************************Post Thread**************************/
  const getGroupPost = async () => {
    try {
      setPostLoading(true);
      setImageLoading(true);
      const response = await axios.post(webServiceUrl.get_community_threads, {
        school_code: course?.school_code,
        student_id: courseData?.student_id,
      });

      // console.log(response.data.data, "get_community_threads");
      setGroupPosts(response.data.data ?? []);
    } catch (error) {
      console.error(error);
      setGroupPosts([])
    } finally {
      setTimeout(() => setPostLoading(false), 1000);
      setTimeout(() => setImageLoading(false), 2500);
    }
  };

  const like_post = async (post_id) => {
    console.log(post_id, "like post");

    try {
      const response = await axios.post(webServiceUrl.like_post, {
        school_code: course?.school_code,
        post_id: post_id,
        liked_by_id: courseData?.student_id,
        liked_sender_name: courseData?.student_name,
      });
      getGroupPost();
      console.log("Post liked successfully:", response.data);

      // Optionally update UI here (like incrementing like count)
    } catch (error) {
      // Silent error handling (just log)
      if (error.response) {
        console.log(
          "Server responded with error:",
          error.response.data?.message || "Unknown server error"
        );
      } else if (error.request) {
        console.error("No response received from server");
      } else {
        console.error("Error during request setup:", error.message);
      }

      // Do nothing in UI
    }
  };

  const like_comment = async (comment_id) => {
    console.log(comment_id, "like post");
    console.log(webServiceUrl.like_comment);

    try {
      const response = await axios.post(webServiceUrl.like_comment, {
        school_code: course?.school_code,
        comment_id: comment_id,
        liked_by_id: courseData?.student_id,
        liked_sender_name: courseData?.student_name,
      });
      getGroupPost();
      console.log("Comment liked successfully:", response.data);

      // Optionally update UI here (like incrementing like count)
    } catch (error) {
      // Silent error handling (just log)
      if (error.response) {
        console.log(
          "Server responded with error:",
          error.response.data?.message || "Unknown server error"
        );
      } else if (error.request) {
        console.log("No response received from server");
      } else {
        console.log("Error during request setup:", error.message);
      }

      // Do nothing in UI
    }
  };
  const comment_post = async () => {
    try {
      const response = await axios.post(
        webServiceUrl.post_comments,
        commentData
      );
      console.log("Post liked successfully:", response.data);
      getGroupPost();
      setCommentData({ ...commentData, post_id: "", comment: "" });
      // Optionally update UI here (like incrementing like count)
    } catch (error) {
      // Silent error handling (just log)
      if (error.response) {
        console.log(
          "Server responded with error:",
          error.response.data?.message || "Unknown server error"
        );
      } else if (error.request) {
        console.log("No response received from server");
      } else {
        console.log("Error during request setup:", error.message);
      }

      // Do nothing in UI
    }
  };

  useEffect(() => {
    getGroupPost();
  }, []);

  if (pageLoading) {
    return (
      <div
        className="d-flex justify-content-center "
        style={{ height: "85vh", paddingTop: "15vh" }}
      >
        <Oval
          height="45"
          width="45"
          color="#4fa94d"
          secondaryColor="#4fa94d"
        />
      </div>
    )
  };

  return (
    <>
      <ProfileHeader img={header} title="Groups" />
      <div id="content-page" className="content-page">
        <Container>
          <Row>
            <Col lg="12">
              <div className="d-flex align-items-center justify-content-between mb-3 flex-wrap">
                <div className="group-info d-flex align-items-center">
                  <div className="me-3 borde border-2 avatar-90 rounded-circle overflow-hidden bg-white">
                    <img
                      className="img-fluid object-fit-cover"
                      src={course?.logo_image}
                      alt=""
                      style={{ width: '90%' }}
                    />
                  </div>
                  <div className="info">
                    <h4>{course?.school_name}...</h4>
                    <p className="mb-0">
                      {/* <i className="ri-lock-fill pe-2"></i> */}
                      {/* {data.totalMembers} members */}
                    </p>
                  </div>
                </div>
              </div>
            </Col>
            <Col lg="8" className="post-card">
              <CreatePost postData={postData} getGroupPost={getGroupPost} />
              <Card>
                <Card.Body className="px-3">
                  {(postLoading && groupposts?.length)
                    ? <><Loading /></>
                    : (<>
                      {groupposts?.map((item, index) => (
                        <div
                          className="card-block post-item mb-5 p-4 shadow-sm border rounded"
                          key={index}
                        >

                          {/* User Info */}
                          <div className="user-post-data d-flex mb-3 ">
                            <img
                              className="rounded-circle me-3"
                              style={{
                                width: "50px",
                                height: "50px",
                                objectFit: "cover",
                              }}
                              // src={`https://ui-avatars.com/api/name=${encodeURIComponent(
                              //   item.created_sender_name
                              // )}&background=random`}
                              src={`https://ui-avatars.com/api/?name=${encodeURIComponent(
                                item?.created_sender_name
                              )}&background=3d8629&color=fff&bold=true&rounded=true`}
                              alt={item?.created_sender_name}
                            />

                            <div className=" w-100">
                              <div className="d-flex justify-content-between align-items-center">
                                <h5 className="mb-0">
                                  <Link to="#">{item?.created_sender_name}</Link>
                                </h5>

                                <div className="d-flex justify-content-end align-items-center gap-2">
                                  <small className="text-muted">
                                    {formatDistanceToNow(new Date(item?.post_date), {
                                      addSuffix: true,
                                    })}
                                  </small>
                                  <div>
                                    <IconButton
                                      aria-label="more"
                                      aria-controls={anchorEl && activePostId === item?.post_id ? 'long-menu' : undefined}
                                      aria-haspopup="true"
                                      onClick={(e) => handleClick(e, item?.post_id)}
                                    >
                                      <MoreVertIcon />
                                    </IconButton>
                                    <Menu
                                      id="long-menu"
                                      anchorEl={anchorEl}
                                      open={Boolean(anchorEl) && activePostId === item?.post_id}
                                      onClose={handleClose3}
                                      slotProps={{
                                        paper: {
                                          style: {
                                            maxHeight: ITEM_HEIGHT * 4.5,
                                            width: '20ch',
                                          },
                                        },
                                        list: {
                                          'aria-labelledby': 'long-button',
                                        },
                                      }}
                                    >
                                      {options?.map((option) => (
                                        <MenuItem key={option} selected={option === 'Pyxis'} onClick={() => handleDelete(option, item?.post_id)}>
                                          {option}
                                        </MenuItem>
                                      ))}
                                    </Menu>
                                  </div></div>
                              </div>
                            </div>
                          </div>

                          {/* Post Description */}
                          <div
                            className="mb-3"
                            style={{
                              whiteSpace: "pre-wrap",
                              wordWrap: "break-word",
                            }}
                          >
                            {item?.post_description}
                          </div>

                          {/* Post Image */}
                          <div>
                            {/* {item?.image_url && ( */}
                            <div className="image-block position-relative productCardImg overflow-hidden">
                              {imageLoading && <Skeleton height={200} className="rounded-3" />}
                              <div className="h-100 w-100 d-flex align-items-center justify-content-center">
                                <img
                                  src={course?.logo_image}
                                  className="img-fluid group-detail-post-image object-fit-cover rounded"
                                  alt="product-img"
                                  style={{ display: imageLoading ? "none" : "block" }}
                                // onLoad={() => setLoading(false)}
                                />
                                
                              </div>
                              
                              {/* <h6 className="price cursor-pointer secondaryBG ">Enroll Now</h6> */}
                            </div>
                            {/* )} */}
                          </div>

                          {/* Likes and Comments Count */}
                          <div className="d-flex justify-content-between align-items-center mt-3">
                            <div className="d-flex align-items-center">
                              {item?.self_liked === 1 ? (
                                <BiSolidLike color="#3D8629" size={20} />
                              ) : (
                                <AiOutlineLike
                                  onClick={() => like_post(item?.post_id)}
                                  color="#3D8629"
                                  size={20}
                                />
                              )}
                              <Dropdown className="ms-2">
                                <Dropdown.Toggle as={CustomToggle}>
                                  {item?.likes} Likes
                                </Dropdown.Toggle>
                              </Dropdown>
                            </div>
                            <div className="d-flex align-items-center">
                              {/* <i className="material-symbols-outlined text-secondary me-1">
                                comment
                              </i> */}
                              <MdComment className="text-secondary me-1" size={18} />
                              <Dropdown>
                                <Dropdown.Toggle as={CustomToggle}>
                                  {item?.comment_count} Comments
                                </Dropdown.Toggle>
                              </Dropdown>
                            </div>
                          </div>

                          <hr />

                          {/* Comments */}
                          <ul className="list-unstyled">
                            {JSON.parse(item?.comments)?.map((comment, idx) => (
                              <li key={idx} className="mb-3">
                                <div className="d-flex align-items-start">
                                  <img
                                    src={`https://ui-avatars.com/api/name=${encodeURIComponent(
                                      comment?.commented_sender_name
                                    )}&background=random`}
                                    alt="user avatar"
                                    className="avatar-35 rounded-circle img-fluid me-2"
                                    style={{ width: "35px", height: "35px" }}
                                  />
                                  <div className="d-flex gap-4">
                                    <div>
                                      <h6 className="mb-1">
                                        {comment?.commented_sender_name}
                                      </h6>
                                      <div className="mb-1">{comment?.comment}</div>
                                    </div>
                                    <div className="d-flex gap-2 align-items-top mt-1">
                                      {comment.self_liked === 1 ? (
                                        <BiSolidLike color="grey" size={16} />
                                      ) : (
                                        <AiOutlineLike
                                          onClick={() =>
                                            like_comment(comment.comment_id)
                                          }
                                          color="grey"
                                          size={16}
                                        />
                                      )}
                                      <span>{comment.comment_likes}</span>
                                      <span className="text-muted small">
                                        {comment.timeAgo}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </li>
                            ))}
                          </ul>

                          {/* Add Comment */}
                          <form className="d-flex align-items-center mt-3">
                            <input
                              type="text"
                              className="form-control rounded me-2"
                              placeholder="Enter your comment"
                              value={
                                item.post_id === commentData.post_id
                                  ? commentData.comment
                                  : ""
                              }
                              onChange={(e) =>
                                setCommentData({
                                  ...commentData,
                                  comment: e.target.value,
                                  post_id: item.post_id,
                                })
                              }
                            />
                            <IoSendSharp
                              size={20}
                              color="#3D8629"
                              onClick={comment_post}
                              className="cursor-pointer"
                            />
                          </form>
                        </div>
                      ))}
                    </>)
                  }
                </Card.Body>
              </Card>
            </Col>
            <Col lg="4">
              {/* <Card>
                <Card.Header className="card-header d-flex justify-content-between">
                  <div className="header-title">
                    <h4 className="card-title">About</h4>
                  </div>
                </Card.Header>
                <Card.Body className="pt-0">
                  <ul className="list-inline p-0 m-0">
                    <li className="mb-3">
                      <p className="mb-0">{data?.groupAbout?.description}</p>
                    </li>
                    <li className="mb-3">
                      <div className="d-flex">
                        <div className="flex-shrink-0">
                          <i className="material-symbols-outlined">lock</i>
                        </div>
                        <div className="flex-grow-1 ms-3">
                          <h6>Private</h6>
                          <p className="mb-0">
                            {data?.groupAbout?.privateText}
                          </p>
                        </div>
                      </div>
                    </li>
                    <li className="mb-3">
                      <div className="d-flex">
                        <div className="flex-shrink-0">
                          <i className="material-symbols-outlined">
                            visibility
                          </i>
                        </div>
                        <div className="flex-grow-1 ms-3">
                          <h6>Visible</h6>
                          <p className="mb-0">
                            {data?.groupAbout?.visibleText}
                          </p>
                        </div>
                      </div>
                    </li>

                    <li className="mb-3">
                      <div className="d-flex">
                        <div className="flex-shrink-0">
                          <i className="material-symbols-outlined">lightbulb</i>
                        </div>
                        <div className="flex-grow-1 ms-3">
                          <h6>Share Your Ideas</h6>
                          <p className="mb-0">{data?.groupAbout?.ideasText}</p>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="d-flex">
                        <div className="flex-shrink-0">
                          <i className="material-symbols-outlined">group</i>
                        </div>
                        <div className="flex-grow-1 ms-3">
                          <h6>Collaborative Community</h6>
                          <p className="mb-0">
                            {data?.groupAbout?.collaborativeText}
                          </p>
                        </div>
                      </div>
                    </li>
                  </ul>
                </Card.Body>
              </Card> */}
              <Card>
                <Card.Header className="card-header d-flex justify-content-between">
                  <div className="header-title">
                    <h4 className="card-title">About</h4>
                  </div>
                </Card.Header>
                <Card.Body className="pt-0">
                  <ul className="list-inline p-0 m-0">
                    <li className="mb-3">
                      <p className="mb-0">
                        A community for AI and Robotics lovers to learn and innovate
                        together.
                      </p>
                    </li>
                    <li className="mb-3">
                      <div className="d-flex">
                        <div className="flex-shrink-0">
                          <i className="material-symbols-outlined">lock</i>
                        </div>
                        <div className="flex-grow-1 ms-3">
                          <h6>Private</h6>
                          <p className="mb-0">
                            A dedicated space for students passionate about
                            robotics, AI, and automation.
                          </p>
                        </div>
                      </div>
                    </li>
                    <li className="mb-3">
                      <div className="d-flex">
                        <div className="flex-shrink-0">
                          <i className="material-symbols-outlined">
                            visibility
                          </i>
                        </div>
                        <div className="flex-grow-1 ms-3">
                          <h6>Visible</h6>
                          <p className="mb-0">
                            Members can view and engage with robotics
                            discussions, projects, and events.
                          </p>
                        </div>
                      </div>
                    </li>

                    <li className="mb-3">
                      <div className="d-flex">
                        <div className="flex-shrink-0">
                          <i className="material-symbols-outlined">lightbulb</i>
                        </div>
                        <div className="flex-grow-1 ms-3">
                          <h6>Share Your Ideas</h6>
                          <p className="mb-0">
                            Post and discuss your innovative robotics ideas with
                            the group.
                          </p>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="d-flex">
                        <div className="flex-shrink-0">
                          <i className="material-symbols-outlined">group</i>
                        </div>
                        <div className="flex-grow-1 ms-3">
                          <h6>Collaborative Community</h6>
                          <p className="mb-0">
                            Connect with like-minded students, share ideas, and
                            build innovative robotic solutions.
                          </p>
                        </div>
                      </div>
                    </li>
                  </ul>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      {/* modals */}
      {/* for nominated  */}
      {/* <Card>
        <Card.Body className="p-0">
          <Modal show={show} onHide={() => setShow(false)}>
            <Modal.Header closeButton>
              <Modal.Title>Nominate</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form onSubmit={handleNominateUser}>
                <Form.Group className="mb-3">
                  <Form.Label>Nomination</Form.Label>
                  <Form.Select
                    name="nomination"
                    value={nominateUsers.nomination}
                    onChange={handleNominateInput}
                  >
                    <option value="">Select Nomination</option>
                    <option value="Collaborative">Collaborative</option>
                    <option value="Responsive">Responsive</option>
                    <option value="Great Job">Great Job</option>
                    <option value="Thank You!">Thank You!</option>
                    <option value="Innovative">Innovative</option>
                  </Form.Select>
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Citation</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    placeholder="Enter Citation"
                    name="message"
                    value={nominateUsers.message}
                    onChange={handleNominateInput}
                  />
                </Form.Group>

                <div className="d-flex justify-content-end ">
                  <Button type="submit" variant="primary">
                    Submit Nomination
                  </Button>
                </div>
              </Form>
            </Modal.Body>
          </Modal>
        </Card.Body>
      </Card> */}

      {/* for Appreciated */}
      {/* <Card>
        <Card.Body className="p-0">
          <Modal scrollable={true} show={show2} onHide={handleClose2}>
            <Modal.Header closeButton>
              <Modal.Title className="h5">Appreciate</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form onSubmit={appreciateUser}>
                <Form.Group className="mb-3">
                  <Form.Label>Message</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    placeholder="Enter Message"
                    onChange={handleAppreciation}
                  />
                </Form.Group>

                <div className="d-flex justify-content-end ">
                  <Button type="submit" variant="primary">
                    Submit Appreciation
                  </Button>
                </div>
              </Form>
            </Modal.Body>
          </Modal>
        </Card.Body>
      </Card> */}
      {/* 🔔 ToastContainer */}
      <ToastContainer
        position="top-right"
        autoClose={3000}
        style={{ fontSize: "15px" }}
      />
    </>
  );
};

export default GroupDetail;
// OLD
// import React, { useEffect, useState } from "react";
// import {
//   Container,
//   Row,
//   Col,
//   Card,
//   Dropdown,
//   Button,
//   OverlayTrigger,
//   Tooltip,
//   Modal,
//   Form,
// } from "react-bootstrap";
// import { Link, useLocation } from "react-router-dom";
// import ProfileHeader from "../../../components/profile-header";
// import CustomToggle from "../../../components/dropdowns";
// import CreatePost from "../../../components/create-post";
// import ShareOffcanvas from "../../../components/share-offcanvas";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import { formatDistanceToNow } from 'date-fns';
// import { AiOutlineLike } from "react-icons/ai";
// import { BiSolidLike } from "react-icons/bi";
// import { IoSendSharp } from "react-icons/io5";

// //image
// import header from "../../../assets/images/page-img/profile-bg7.jpg";
// import axios from "axios";
// import { webServiceUrl } from "../../../components/apiCall/webserviceurl";

// const GroupDetail = () => {
//    const location = useLocation();
//     console.log(location);
//    const course = location?.state?.item ?? {}
//   const courseData?. = course?.student ?? localStorage.getItem("userId")
//   console.log(course, "course details at blogdetails ...........");
//   console.log(course?.student, "course details at blogdetails ...........");
//   const handleShow = () => setShow(true);
//   const [show, setShow] = useState(false);
//   const handleClose = () => setShow(false);
//   const [show2, setShow2] = useState(false);
//   const handleClose2 = () => setShow2(false);
//   const handleShow2 = () => setShow2(true);

//   const [data, setData] = useState({});
//   const [groupposts, setGroupPosts] = useState([]);

//   const [appreciateUsers, setAppreciateUsers] = useState({
//     message: "",
//     sender_id: 12345,
//     receiver_id: 67890,
//   });

//   const [nominateUsers, setNominateUsers] = useState({
//     nomination: "",
//     message: "",
//     receiver_id: 12345,
//     sender_id: 67890,
//   });
// const [postData,setPostData]=useState({
//   school_code:course?.school_code,
//   post_description:"",
//   created_by_id:courseData?.student_id,
//   created_sender_name:courseData?.student_name,
//   post_img:""
// })
// const [commentData,setCommentData]=useState({
//   school_code:course?.school_code,
//       post_id:"",
//       comment:"",
//       commented_by_id:courseData?.student_id,
//       commented_sender_name:courseData?.student_name
// })
// console.log(commentData,"commentData.........................");

//   /****************************************Post Thread**************************/

//  const like_post = async (post_id) => {
//   console.log(post_id, "like post");

//   try {
//     const response = await axios.post(webServiceUrl.like_post, {
//       school_code: course?.school_code,
//       post_id: post_id,
//       liked_by_id: courseData?.student_id,
//       liked_sender_name: courseData?.student_name
//     });

//     console.log("Post liked successfully:", response.data);

//     // Optionally update UI here (like incrementing like count)
//   } catch (error) {
//     // Silent error handling (just log)
//     if (error.response) {
//       console.log("Server responded with error:", error.response.data?.message || "Unknown server error");
//     } else if (error.request) {
//       console.log("No response received from server");
//     } else {
//       console.log("Error during request setup:", error.message);
//     }

//     // Do nothing in UI
//   }
// };
//  const comment_post = async (post_id) => {
//   console.log(post_id, "like post");

//   try {
//     const response = await axios.post(webServiceUrl.post_comments, {

//     });

//     console.log("Post liked successfully:", response.data);

//     // Optionally update UI here (like incrementing like count)
//   } catch (error) {
//     // Silent error handling (just log)
//     if (error.response) {
//       console.log("Server responded with error:", error.response.data?.message || "Unknown server error");
//     } else if (error.request) {
//       console.log("No response received from server");
//     } else {
//       console.log("Error during request setup:", error.message);
//     }

//     // Do nothing in UI
//   }
// };

//   const getGroupPost = async () => {
//     const groupId = "4444646646";
//     const response = await axios.post(webServiceUrl.get_community_threads, {
//       school_code:course?.school_code
//     });

//     // console.log(response.data.data, "get_community_threads");
//     setGroupPosts(response.data.data);
//   };

//   useEffect(() => {
//     getGroupPost();
//   }, []);

//   return (
//     <>
//       <ProfileHeader img={header} title="Groups" />
//       <div id="content-page" className="content-page">
//         <Container>
//           <Row>
//             <Col lg="12">
//               <div className="d-flex align-items-center justify-content-between mb-3 flex-wrap">
//                 <div className="group-info d-flex align-items-center">
//                   <div className="me-3">
//                     <img
//                       className="rounded-circle img-fluid avatar-100"
//                       src={course?.logo_image}
//                       alt=""
//                     />
//                   </div>
//                   <div className="info">
//                     <h4>{course?.school_name}...</h4>
//                     <p className="mb-0">
//                       {/* <i className="ri-lock-fill pe-2"></i> */}
//                       {/* {data.totalMembers} members */}
//                     </p>
//                   </div>
//                 </div>
//               </div>
//             </Col>
//             <Col lg="8" className="post-card">
//               <CreatePost postData={postData} />
//               <Card>
//                 <Card.Body>
//                   {groupposts.map((item, index) => (
//                     <div className="post-item">
//                       <div className="user-post-data py-3">
//                         <div className="d-flex justify-content-between">
//                           <div
//                             className=" me-3"
//                             // style={{ width: "65px", height: "auto" }}
//                           >
//                             <img
//                               className="rounded-circle avatar-40"
//                               src={`https://ui-avatars.com/api/name=${encodeURIComponent(item.created_sender_name)}&background=random`}
//                               alt=""
//                             />
//                           </div>
//                           <div className="w-100">
//                             <div className="d-flex justify-content-between">
//                               <div>
//                                 <h5 className="mb-0 d-inline-block">
//                                   <Link to="#">{item.created_sender_name}</Link>
//                                 </h5>
//                                 <p className="mb-0">{formatDistanceToNow(new Date(item.post_date), { addSuffix: true })}</p>
//                               </div>

//                             </div>
//                               <div
//   style={{
//     whiteSpace: 'pre-wrap',
//     width: '100%',         // or a specific width like '400px'
//     wordWrap: 'break-word' // helps break long words if needed
//   }}
// >
//   {item.post_description}
// </div>

//                                <div
//                             // className=" me-3"
//                             // style={{ width: "auto", height: "auto" }}
//                           >
//                             <img
//                               className="img-fluid"
//                               src={item.image_url}
//                               alt=""
//                             />
//                           </div>
//                           </div>
//                         </div>
//                       </div>
//                       <div>
//                         <h5 className="my-2">
//                           {/* {item?.postContent?.contentTitle} */}
//                         </h5>
//                         <p className="mb-1">
//                           {/* {item?.postContent?.contentDescription} */}
//                         </p>
//                       </div>
//                       <div className="user-post mt-4">
//                         <Link to="">
//                           {/* <img
//                             className="img-fluid w-100"
//                             src={item.postContent.contentDescriptionImage}
//                             alt="postimage"
//                           /> */}
//                         </Link>
//                       </div>
//                       <div className="comment-area mt-3">
//                         <div className="d-flex justify-content-between align-items-center flex-wrap">
//                           <div className="like-block position-relative d-flex align-items-center">
//                             <div className="d-flex align-items-center">
//                               <div className="total-like-block ms-2 me-3 d-flex align-items-center">
//                                {item.self_liked==1?<BiSolidLike color="#3D8629" size={17} />:
//  <AiOutlineLike onClick={()=>like_post(item.post_id)} color="#3D8629" size={17} />}

//                                 {/* <i
//                                   className="material-symbols-outlined text-primary me-1"
//                                   style={{ fontSize: "1rem" ,backgroundColor=""}}

//                                 >
//                                   thumb_up
//                                 </i> */}
//                                 <Dropdown>
//                                   <Dropdown.Toggle as={CustomToggle}>
//                                     {item?.likes} Likes
//                                   </Dropdown.Toggle>
//                                 </Dropdown>
//                               </div>
//                             </div>
//                             <div className="total-comment-block d-flex align-items-center">
//                               <i
//                                 className="material-symbols-outlined text-secondary me-1"
//                                 style={{ fontSize: "1rem" }}
//                               >
//                                 comment
//                               </i>
//                               <Dropdown>
//                                 <Dropdown.Toggle as={CustomToggle}>
//                                   20 Comments
//                                 </Dropdown.Toggle>
//                               </Dropdown>
//                             </div>
//                           </div>

//                           {/* <ShareOffcanvas /> */}
//                         </div>
//                         <hr />
//                         {/* <ul className="post-comments p-0 m-0">
//                           {item.comments.map((comments, index) => (
//                             <li className="mb-2">
//                               <div className="d-flex">
//                                 <div className="user-img">
//                                   <img
//                                     src={comments.profileImage}
//                                     alt="userimg"
//                                     className="avatar-35 rounded-circle img-fluid"
//                                   />
//                                 </div>
//                                 <div className="comment-data-block ms-3">
//                                   <div className="d-flex gap-3">
//                                     <h6>{comments.user}</h6>
//                                     <div className="d-flex gap-2">
//                                       <i
//                                         className="material-symbols-outlined cursor-pointer"
//                                         style={{
//                                           fontSize: "14px",
//                                           margin: "auto 0",
//                                         }}
//                                         title="Appreciate"
//                                         onClick={handleShow2}
//                                       >
//                                         thumb_up
//                                       </i>
//                                       <i
//                                         className="material-symbols-outlined cursor-pointer"
//                                         style={{
//                                           fontSize: "15px",
//                                           margin: "auto 0",
//                                         }}
//                                         title="Nominate"
//                                         onClick={handleShow}
//                                       >
//                                         emoji_events
//                                       </i>
//                                     </div>
//                                   </div>

//                                   <p className="mb-0">{comments.text}</p>
//                                   <div className="d-flex flex-wrap align-items-center comment-activity">
//                                     <Link to="">like</Link>
//                                     <Link to="">reply</Link>
//                                     <Link to="">translate</Link>
//                                     <span> {comments.timeAgo} </span>
//                                   </div>
//                                 </div>
//                               </div>
//                             </li>
//                           ))}
//                         </ul> */}
//                         <form
//                           className="comment-text d-flex align-items-center mt-3"
//                           action=""
//                         >
//                           <input
//                             type="text"
//                             className="form-control rounded"
//                             placeholder="Enter Your Comment"
//                             value={commentData.comment}
//                             onChange={(e) =>{
//                               setCommentData({...commentData,comment:e.target.value,post_id:item.post_id})

//                             }}
//                           />
//                           <div className="comment-attagement d-flex">
//                             <IoSendSharp color="#3D8629" className="me-3"/>

//                             {/* <Link to="">
//                               <i className="ri-link me-3"></i>
//                             </Link>
//                             <Link to="">
//                               <i className="ri-user-smile-line me-3"></i>
//                             </Link>
//                             <Link to="">
//                               <i className="ri-camera-line me-3"></i>
//                             </Link> */}
//                           </div>
//                         </form>
//                       </div>
//                     </div>
//                   ))}

//                   {/* post 2 */}
//                   <hr className="4" />
//                   {/* <div className="post-item">
//                     <div className="user-post-data py-3">
//                       <div className="d-flex justify-content-between">
//                         <div className=" me-3">
//                           <img
//                             className="rounded-circle img-fluid"
//                             src={img6}
//                             alt=""
//                           />
//                         </div>
//                         <div className="w-100">
//                           <div className="d-flex justify-content-between">
//                             <div>
//                               <h5 className="mb-0 d-inline-block">
//                                 <Link to="#">Anna Sthesia </Link>
//                               </h5>
//                               <p className="mb-0">8 hour ago</p>
//                             </div>
//                             <div className="card-post-toolbar">
//                               <Dropdown>
//                                 <Dropdown.Toggle variant="bg-transparent">
//                                   <span className="material-symbols-outlined">
//                                     more_horiz
//                                   </span>
//                                 </Dropdown.Toggle>
//                                 <Dropdown.Menu className="dropdown-menu m-0 p-0">
//                                   <Dropdown.Item
//                                     className="dropdown-item p-3"
//                                     to="#"
//                                   >
//                                     <div className="d-flex align-items-top">
//                                       <i className="material-symbols-outlined">
//                                         save
//                                       </i>
//                                       <div className="data ms-2">
//                                         <h6>Save Post</h6>
//                                         <p className="mb-0">
//                                           Add this to your saved items
//                                         </p>
//                                       </div>
//                                     </div>
//                                   </Dropdown.Item>
//                                   <Dropdown.Item
//                                     className="dropdown-item p-3"
//                                     to="#"
//                                   >
//                                     <div className="d-flex align-items-top">
//                                       <i className="material-symbols-outlined">
//                                         edit
//                                       </i>
//                                       <div className="data ms-2">
//                                         <h6>Edit Post</h6>
//                                         <p className="mb-0">
//                                           Update your post and saved items
//                                         </p>
//                                       </div>
//                                     </div>
//                                   </Dropdown.Item>
//                                   <Dropdown.Item
//                                     className="dropdown-item p-3"
//                                     to="#"
//                                   >
//                                     <div className="d-flex align-items-top">
//                                       <i className="material-symbols-outlined">
//                                         cancel
//                                       </i>
//                                       <div className="data ms-2">
//                                         <h6>Hide From Timeline</h6>
//                                         <p className="mb-0">
//                                           See fewer posts like this.
//                                         </p>
//                                       </div>
//                                     </div>
//                                   </Dropdown.Item>
//                                   <Dropdown.Item
//                                     className="dropdown-item p-3"
//                                     to="#"
//                                   >
//                                     <div className="d-flex align-items-top">
//                                       <i className="material-symbols-outlined">
//                                         delete
//                                       </i>
//                                       <div className="data ms-2">
//                                         <h6>Delete</h6>
//                                         <p className="mb-0">
//                                           Remove thids Post on Timeline
//                                         </p>
//                                       </div>
//                                     </div>
//                                   </Dropdown.Item>
//                                   <Dropdown.Item
//                                     className="dropdown-item p-3"
//                                     to="#"
//                                   >
//                                     <div className="d-flex align-items-top">
//                                       <i className="material-symbols-outlined">
//                                         notifications
//                                       </i>
//                                       <div className="data ms-2">
//                                         <h6>Notifications</h6>
//                                         <p className="mb-0">
//                                           Turn on notifications for this post
//                                         </p>
//                                       </div>
//                                     </div>
//                                   </Dropdown.Item>
//                                 </Dropdown.Menu>
//                               </Dropdown>
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                     <div>
//                       <p className="mb-1">
//                         <strong>What is Robotics?</strong> Robotics is a branch
//                         of technology that focuses on designing, building, and
//                         programming robots to perform tasks autonomously or with
//                         minimal human intervention.
//                       </p>

//                       <p className="mb-1">
//                         <strong>Applications:</strong> Robotics plays a crucial
//                         role in various industries, including:
//                       </p>

//                       <ul className="mb-1">
//                         <li>
//                           <strong>🏭 Manufacturing:</strong> Automating assembly
//                           lines and precision tasks.
//                         </li>
//                         <li>
//                           <strong>🏥 Healthcare:</strong> Assisting in
//                           surgeries, rehabilitation, and patient care.
//                         </li>
//                         <li>
//                           <strong>🚀 Space Exploration:</strong> Enabling remote
//                           planetary exploration and research.
//                         </li>
//                       </ul>

//                       <p className="mb-1">
//                         <strong>Key Components:</strong> A robot typically
//                         consists of:
//                       </p>

//                       <ul>
//                         <p>
//                           <strong>🟢 Sensors:</strong> Collect environmental
//                           data to make informed decisions.
//                         </p>
//                         <p>
//                           <strong>🔵 Actuators:</strong> Convert electrical
//                           signals into movement or action.
//                         </p>
//                         <p>
//                           <strong>🟠 Control System:</strong> Processes data and
//                           executes commands to perform tasks.
//                         </p>
//                       </ul>
//                     </div>

//                     <div className="user-post mt-4">
//                       <Link to="">
//                         <img
//                           className="img-fluid w-100"
//                           src={img9}
//                           alt="postimage"
//                         />
//                       </Link>
//                     </div>
//                     <div className="comment-area mt-3">
//                       <div className="d-flex justify-content-between align-items-center flex-wrap">
//                         <div className="like-block position-relative d-flex align-items-center">
//                           <div className="d-flex align-items-center">
//                             <div className="total-like-block ms-2 me-3 d-flex align-items-center">
//                               <i
//                                 className="material-symbols-outlined text-primary me-1"
//                                 style={{ fontSize: "1rem" }}
//                               >
//                                 thumb_up
//                               </i>
//                               <Dropdown>
//                                 <Dropdown.Toggle as={CustomToggle}>
//                                   140 Likes
//                                 </Dropdown.Toggle>
//                               </Dropdown>
//                             </div>
//                           </div>
//                           <div className="total-comment-block d-flex align-items-center">
//                             <i
//                               className="material-symbols-outlined text-secondary me-1"
//                               style={{ fontSize: "1rem" }}
//                             >
//                               comment
//                             </i>
//                             <Dropdown>
//                               <Dropdown.Toggle as={CustomToggle}>
//                                 20 Comments
//                               </Dropdown.Toggle>
//                             </Dropdown>
//                           </div>
//                         </div>
//                       </div>
//                       <hr />
//                       <ul className="post-comments p-0 m-0">
//                         <li className="mb-2">
//                           <div className="d-flex">
//                             <div className="user-img">
//                               <img
//                                 src={img10}
//                                 alt="userimg"
//                                 className="avatar-35 rounded-circle img-fluid"
//                               />
//                             </div>
//                             <div className="comment-data-block ms-3">
//                               <div className="d-flex gap-3">
//                                 <h6>Sneha Kapoor</h6>
//                                 <div className="d-flex gap-2">
//                                   <i
//                                     className="material-symbols-outlined cursor-pointer"
//                                     style={{
//                                       fontSize: "14px",
//                                       margin: "auto 0",
//                                     }}
//                                     title="Appreciate"
//                                     onClick={handleShow2}
//                                   >
//                                     thumb_up
//                                   </i>
//                                   <i
//                                     className="material-symbols-outlined cursor-pointer"
//                                     style={{
//                                       fontSize: "15px",
//                                       margin: "auto 0",
//                                     }}
//                                     title="Nominate"
//                                     onClick={handleShow}
//                                   >
//                                     emoji_events
//                                   </i>
//                                 </div>
//                               </div>
//                               <p className="mb-0">
//                                 I never thought about it this way. Great point!
//                                 👏
//                               </p>
//                               <div className="d-flex flex-wrap align-items-center comment-activity">
//                                 <Link to="">like</Link>
//                                 <Link to="">reply</Link>
//                                 <Link to="">translate</Link>
//                                 <span> 5 min </span>
//                               </div>
//                             </div>
//                           </div>
//                         </li>
//                         <li>
//                           <div className="d-flex">
//                             <div className="user-img">
//                               <img
//                                 src={img11}
//                                 alt="userimg"
//                                 className="avatar-35 rounded-circle img-fluid"
//                               />
//                             </div>
//                             <div className="comment-data-block ms-3">
//                               <div className="d-flex gap-3">
//                                 <h6>Vijay Thakur</h6>
//                                 <div className="d-flex gap-2">
//                                   <i
//                                     className="material-symbols-outlined cursor-pointer"
//                                     style={{
//                                       fontSize: "14px",
//                                       margin: "auto 0",
//                                     }}
//                                     title="Appreciate"
//                                     onClick={handleShow2}
//                                   >
//                                     thumb_up
//                                   </i>
//                                   <i
//                                     className="material-symbols-outlined cursor-pointer"
//                                     style={{
//                                       fontSize: "15px",
//                                       margin: "auto 0",
//                                     }}
//                                     title="Nominate"
//                                     onClick={handleShow}
//                                   >
//                                     emoji_events
//                                   </i>
//                                 </div>
//                               </div>
//                               <p className="mb-0">
//                                 This perspective is really interesting. Thanks
//                                 for sharing! 💡
//                               </p>
//                               <div className="d-flex flex-wrap align-items-center comment-activity">
//                                 <Link to="">like</Link>
//                                 <Link to="">reply</Link>
//                                 <Link to="">translate</Link>
//                                 <span> 5 min </span>
//                               </div>
//                             </div>
//                           </div>
//                         </li>
//                       </ul>
//                       <form
//                         className="comment-text d-flex align-items-center mt-3"
//                         action=""
//                       >
//                         <input
//                           type="text"
//                           className="form-control rounded"
//                           placeholder="Enter Your Comment"
//                         />
//                         <div className="comment-attagement d-flex">
//                           <Link to="">
//                             <i className="ri-link me-3"></i>
//                           </Link>
//                           <Link to="">
//                             <i className="ri-user-smile-line me-3"></i>
//                           </Link>
//                           <Link to="">
//                             <i className="ri-camera-line me-3"></i>
//                           </Link>
//                         </div>
//                       </form>
//                     </div>
//                   </div> */}
//                 </Card.Body>
//               </Card>
//             </Col>
//             <Col lg="4">
//               <Card>
//                 <Card.Header className="card-header d-flex justify-content-between">
//                   <div className="header-title">
//                     <h4 className="card-title">About</h4>
//                   </div>
//                 </Card.Header>
//                 <Card.Body className="pt-0">
//                   <ul className="list-inline p-0 m-0">
//                     <li className="mb-3">
//                       <p className="mb-0">{data?.groupAbout?.description}</p>
//                     </li>
//                     <li className="mb-3">
//                       <div className="d-flex">
//                         <div className="flex-shrink-0">
//                           <i className="material-symbols-outlined">lock</i>
//                         </div>
//                         <div className="flex-grow-1 ms-3">
//                           <h6>Private</h6>
//                           <p className="mb-0">
//                             {data?.groupAbout?.privateText}
//                           </p>
//                         </div>
//                       </div>
//                     </li>
//                     <li className="mb-3">
//                       <div className="d-flex">
//                         <div className="flex-shrink-0">
//                           <i className="material-symbols-outlined">
//                             visibility
//                           </i>
//                         </div>
//                         <div className="flex-grow-1 ms-3">
//                           <h6>Visible</h6>
//                           <p className="mb-0">
//                             {data?.groupAbout?.visibleText}
//                           </p>
//                         </div>
//                       </div>
//                     </li>

//                     <li className="mb-3">
//                       <div className="d-flex">
//                         <div className="flex-shrink-0">
//                           <i className="material-symbols-outlined">lightbulb</i>
//                         </div>
//                         <div className="flex-grow-1 ms-3">
//                           <h6>Share Your Ideas</h6>
//                           <p className="mb-0">{data?.groupAbout?.ideasText}</p>
//                         </div>
//                       </div>
//                     </li>
//                     <li>
//                       <div className="d-flex">
//                         <div className="flex-shrink-0">
//                           <i className="material-symbols-outlined">group</i>
//                         </div>
//                         <div className="flex-grow-1 ms-3">
//                           <h6>Collaborative Community</h6>
//                           <p className="mb-0">
//                             {data?.groupAbout?.collaborativeText}
//                           </p>
//                         </div>
//                       </div>
//                     </li>
//                   </ul>
//                 </Card.Body>
//               </Card>
//             </Col>
//           </Row>
//         </Container>
//       </div>

//       {/* modals */}
//       {/* for nominated  */}
//       {/* <Card>
//         <Card.Body className="p-0">
//           <Modal show={show} onHide={() => setShow(false)}>
//             <Modal.Header closeButton>
//               <Modal.Title>Nominate</Modal.Title>
//             </Modal.Header>
//             <Modal.Body>
//               <Form onSubmit={handleNominateUser}>
//                 <Form.Group className="mb-3">
//                   <Form.Label>Nomination</Form.Label>
//                   <Form.Select
//                     name="nomination"
//                     value={nominateUsers.nomination}
//                     onChange={handleNominateInput}
//                   >
//                     <option value="">Select Nomination</option>
//                     <option value="Collaborative">Collaborative</option>
//                     <option value="Responsive">Responsive</option>
//                     <option value="Great Job">Great Job</option>
//                     <option value="Thank You!">Thank You!</option>
//                     <option value="Innovative">Innovative</option>
//                   </Form.Select>
//                 </Form.Group>

//                 <Form.Group className="mb-3">
//                   <Form.Label>Citation</Form.Label>
//                   <Form.Control
//                     as="textarea"
//                     rows={3}
//                     placeholder="Enter Citation"
//                     name="message"
//                     value={nominateUsers.message}
//                     onChange={handleNominateInput}
//                   />
//                 </Form.Group>

//                 <div className="d-flex justify-content-end ">
//                   <Button type="submit" variant="primary">
//                     Submit Nomination
//                   </Button>
//                 </div>
//               </Form>
//             </Modal.Body>
//           </Modal>
//         </Card.Body>
//       </Card> */}

//       {/* for Appreciated */}
//       {/* <Card>
//         <Card.Body className="p-0">
//           <Modal scrollable={true} show={show2} onHide={handleClose2}>
//             <Modal.Header closeButton>
//               <Modal.Title className="h5">Appreciate</Modal.Title>
//             </Modal.Header>
//             <Modal.Body>
//               <Form onSubmit={appreciateUser}>
//                 <Form.Group className="mb-3">
//                   <Form.Label>Message</Form.Label>
//                   <Form.Control
//                     as="textarea"
//                     rows={3}
//                     placeholder="Enter Message"
//                     onChange={handleAppreciation}
//                   />
//                 </Form.Group>

//                 <div className="d-flex justify-content-end ">
//                   <Button type="submit" variant="primary">
//                     Submit Appreciation
//                   </Button>
//                 </div>
//               </Form>
//             </Modal.Body>
//           </Modal>
//         </Card.Body>
//       </Card> */}
//       {/* 🔔 ToastContainer */}
//       <ToastContainer
//         position="top-right"
//         autoClose={3000}
//         style={{ fontSize: "15px" }}
//       />
//     </>
//   );
// };

// export default GroupDetail;
